module.exports = __webpack_public_path__ + "static/media/spending-categories-2025.51a38527.gif";